export const resolveTranslation = (key: Record<string, string>, language: string) =>
  key[language] || key.English;
